import React, { createContext, useContext, useRef, useCallback } from 'react';

const PageCacheContext = createContext(null);

export function PageCacheProvider({ children }) {
  const cacheRef = useRef({});

  const getCache = useCallback((pageKey) => cacheRef.current[pageKey] || null, []);

  const setCache = useCallback((pageKey, data) => {
    cacheRef.current[pageKey] = data;
  }, []);

  const clearCache = useCallback((pageKey) => {
    if (pageKey) {
      delete cacheRef.current[pageKey];
    } else {
      cacheRef.current = {};
    }
  }, []);

  return (
    <PageCacheContext.Provider value={{ getCache, setCache, clearCache }}>
      {children}
    </PageCacheContext.Provider>
  );
}

export function usePageCache(pageKey) {
  const { getCache, setCache, clearCache } = useContext(PageCacheContext);
  return {
    cache: getCache(pageKey),
    save: (data) => setCache(pageKey, data),
    clear: () => clearCache(pageKey),
  };
}
